import { batchKeys, modificheDeletes } from "./batch";

// The writes that end up in git (a commit and a push each).
export const GIT_CALLERS = [
  "saveDataItem",
  "deleteDataItem",
  "saveModifiche",
  "saveBatch"
];

export const MAIN_REFUSED =
  "Changes cannot be saved on main: switch to a branch";

// main changes only through the release of a branch: no write goes to git
// from main, whatever the page that asks for it.
export const refusedOnMain = (caller, branch) =>
  branch === "main" && GIT_CALLERS.includes(caller);

// The rows a git write sends, as draft keys ("accessor:id"): the items and
// deletes of a batch (the cascade of a property deleted from its list is
// deletes); of modifiche, the rows they delete: the rows the server builds
// from them are not known here.
export function writtenKeys(caller, dataArray = []) {
  const data = dataArray.filter(Boolean);
  if (caller === "saveBatch")
    return data.flatMap((batch) => [
      ...batchKeys(batch),
      ...modificheDeletes(batch.modifiche)
    ]);
  if (caller === "saveDataItem") return batchKeys({ items: data });
  if (caller === "deleteDataItem") return batchKeys({ deletes: data });
  if (caller === "saveModifiche") return data.flatMap(modificheDeletes);

  return [];
}

// A git write that sends a drafted row someone else saved or deleted meanwhile
// (a live conflict of its draft) is refused before it leaves: the server
// would refuse the stale version (409), or create a deleted row again. The
// conflicts come in the shape of a 409 (store: the draft store).
export const liveConflictsOf = (caller, dataArray, store) =>
  GIT_CALLERS.includes(caller)
    ? store.conflictsOf(writtenKeys(caller, dataArray))
    : [];

// The rows a git write sends that are drafted in a scope it does not save
// (scope: the draft the write is the save of, if any). They are read from
// MemoryDB, i.e. that other draft's rows: the write would commit part of a
// draft its page neither shows nor saves. [{ accessor, id, scope }]
export function heldRowsOf(caller, dataArray, store, scope) {
  if (!GIT_CALLERS.includes(caller)) return [];

  const held = [];
  for (const key of new Set(writtenKeys(caller, dataArray))) {
    const at = key.indexOf(":");
    const accessor = key.slice(0, at);
    const id = key.slice(at + 1);
    const holder = store.ownerOf(accessor, id);
    if (holder && holder !== scope) held.push({ accessor, id, scope: holder });
  }
  return held;
}
